import * as api from "@/api/williams/project";
import { Project } from "@/api/project";
import { queryKeys } from "../../queryKeys";
import { routes } from "../../routes";
import { useMutation, useQueryClient } from "react-query";
import { usePinProject } from "./usePinProject";

export function useSaveProject() {
  const queryClient = useQueryClient();
  const pinProject = usePinProject();

  return useMutation(async (project: Project) => {
    const updatedProject = await api.saveProject(project);

    queryClient.setQueryData(queryKeys.project.single(project.id), updatedProject);

    queryClient.invalidateQueries(queryKeys.project.list());
    queryClient.invalidateQueries(queryKeys.scopeOfWork.all());
    queryClient.invalidateQueries(queryKeys.testEvent.all());

    // Clear similar projects cache.
    queryClient.removeQueries(queryKeys.project.similar(project));

    if (window.location.href.endsWith(routes.project.create)) {
      // Automatically add new projects to favorites.
      pinProject.mutate(updatedProject.id);
    }

    return updatedProject;
  });
}
